import { useSelector } from 'react-redux'
import { RoleName } from '@pbt/pbt-ui-components'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'
import useHasRole from '~/utils/useHasRole'

export const useAudioRecorderVisibility = () => {
  const ftEnabled = useSelector(getFeatureToggle(FeatureToggle.AUDIO_RECORDER))
  const hasRole = useHasRole(RoleName.Marketing)

  // URL check - only show on pims.* URLs
  const isPimsUrl =
    window.location.hostname.startsWith('pims.') ||
    window.location.hostname === 'localhost'

  if (!isPimsUrl) return { isVisible: false, reason: 'portal-url' }
  if (!ftEnabled) return { isVisible: false, reason: 'ft-disabled' }
  if (!hasRole) return { isVisible: false, reason: 'no-role' }

  return { isVisible: true }
}
